import React from 'react';

import { Roles } from '../../../../routing/child-router-factory';

import {
  CreateConfigFn,
  nonAuthenticatedRedirect,
  pathJoin,
} from '../../../../routing/utils';

import Create from './routes/create';

import ServiceTypeRedirect from './ServiceTypeRedirect';

import SelfService from './routes/exact';

export type Keys =
  | `exact`
  | `create/:ticketTypeId`
  | `redirect/toCreateByServiceType/:serviceType`;

export const createRoutesMap = (prefix: string) => ({
  'create/:ticketTypeId': (ticketTypeId = ':ticketTypeId') =>
    pathJoin(prefix)('create')(ticketTypeId).chain,
  'redirect/toCreateByServiceType/:serviceType': (
    serviceType = ':serviceType'
  ) => pathJoin(prefix)('redirect/toCreateByServiceType')(serviceType).chain,
});

const authenticatedUser: Roles = {
  and: ['authenticated'],
};

// create-config function.
export const createConfig: CreateConfigFn<Keys> = (map) => [
  {
    key: 'create/:ticketTypeId',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <Create />,
    path: map.app.selfService['create/:ticketTypeId']()._,
  },
  {
    key: 'redirect/toCreateByServiceType/:serviceType',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <ServiceTypeRedirect />,
    path: map.app.selfService['redirect/toCreateByServiceType/:serviceType']()
      ._,
  },
  {
    key: 'exact',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,
    children: <SelfService />,
    path: map.app.selfService._,
    exact: true,
  },
];
